
(() => {
  const body = document.body;
  const layer = document.querySelector('[data-cart-layer]');
  const itemsHost = document.querySelector('[data-cart-items]');
  const subtotalHost = document.querySelector('[data-cart-subtotal]');
  const checkoutLink = document.querySelector('[data-cart-checkout]');
  const cartDialog = document.querySelector('[data-cart-dialog]');
  const countHosts = [...document.querySelectorAll('[data-cart-count]')];
  let cartReturnFocus = null;

  const money = (cents) => new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY', maximumFractionDigits: 0 }).format(cents / 100);
  const escape = (value) => String(value ?? '').replace(/[&<>"']/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[char]));

  function openCart() {
    if (!layer) return;
    cartReturnFocus = document.activeElement;
    layer.setAttribute('aria-hidden', 'false');
    body.classList.add('drawerOpen');
    window.requestAnimationFrame(() => cartDialog?.focus());
  }
  function closeCart() {
    if (!layer) return;
    layer.setAttribute('aria-hidden', 'true');
    body.classList.remove('drawerOpen');
    if (cartReturnFocus instanceof HTMLElement) cartReturnFocus.focus();
  }
  const cartItemMarkup = (item) => '<article class="cartLine"><a class="cartLineMedia" href="' + escape(item.url) + '" aria-label="' + escape(item.product_title) + 'を見る">' + (item.image ? '<img src="' + escape(item.image) + '" alt="' + escape(item.product_title) + '">' : '') + '</a><div><h3><a href="' + escape(item.url) + '">' + escape(item.product_title) + '</a></h3><p>' + money(item.final_line_price) + '</p><div class="cartQuantity" aria-label="' + escape(item.product_title) + 'の数量"><button type="button" data-cart-change data-key="' + escape(item.key) + '" data-quantity="' + (item.quantity - 1) + '" aria-label="数量を1点減らす">−</button><span aria-live="polite">' + item.quantity + '</span><button type="button" data-cart-change data-key="' + escape(item.key) + '" data-quantity="' + (item.quantity + 1) + '" aria-label="数量を1点増やす">＋</button></div><a class="cartLineRemove" href="/cart/change?id=' + encodeURIComponent(item.key) + '&quantity=0">削除</a></div></article>';
  async function refreshCart(open = false) {
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json());
    countHosts.forEach((host) => { host.textContent = String(cart.item_count); });
    if (itemsHost) {
      itemsHost.innerHTML = cart.items.length ? cart.items.map(cartItemMarkup).join('') : '<p class="emptyCart">ショッピングバッグは空です。<br><a href="/#new">コレクションを見る</a></p>';
    }
    if (subtotalHost) subtotalHost.textContent = money(cart.total_price);
    if (checkoutLink) checkoutLink.toggleAttribute('hidden', cart.item_count === 0);
    if (open) openCart();
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-cart-toggle]');
    const closer = event.target.closest('[data-cart-close]');
    if (toggle) { event.preventDefault(); refreshCart(true); }
    if (closer) { event.preventDefault(); closeCart(); }
    const quantityButton = event.target.closest('[data-cart-change]');
    if (quantityButton) {
      event.preventDefault();
      quantityButton.disabled = true;
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: quantityButton.dataset.key, quantity: Number(quantityButton.dataset.quantity) }) })
        .then((response) => { if (!response.ok) throw new Error('change failed'); return refreshCart(false); })
        .catch(() => { window.location.href = '/cart'; });
    }
  });

  document.addEventListener('keydown', (event) => {
    if (!layer || layer.getAttribute('aria-hidden') === 'true') return;
    if (event.key === 'Escape') { event.preventDefault(); closeCart(); return; }
    if (event.key !== 'Tab' || !cartDialog) return;
    const focusable = [...cartDialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')];
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-ajax-cart="true"]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (button) button.disabled = true;
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('add failed');
      await refreshCart(true);
    } catch (error) {
      window.location.href = '/cart';
    } finally {
      if (button) button.disabled = false;
    }
  });

  document.querySelectorAll('[data-category-filter]').forEach((button) => {
    button.addEventListener('click', () => {
      const category = button.dataset.categoryFilter;
      document.querySelectorAll('[data-category-filter]').forEach((candidate) => candidate.classList.toggle('active', candidate === button));
      document.querySelectorAll('[data-product-card]').forEach((card) => { card.hidden = category !== 'all' && !card.dataset.categories.split(' ').includes(category); });
      const label = document.querySelector('[data-active-category-label]');
      if (label) label.textContent = button.querySelector('span')?.textContent || 'ALL COLLECTIONS';
      document.getElementById('new')?.scrollIntoView({ behavior: 'smooth' });
    });
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('.storyProductMainImage img');
    gallery.querySelectorAll('[data-gallery-src]').forEach((button) => button.addEventListener('click', () => {
      if (!main) return;
      main.src = button.dataset.gallerySrc;
      main.alt = button.dataset.galleryAlt || '';
      gallery.querySelectorAll('[data-gallery-src]').forEach((candidate) => {
        const active = candidate === button;
        candidate.classList.toggle('isActive', active);
        candidate.setAttribute('aria-pressed', String(active));
      });
    }));
  });
})();
